import { render, staticRenderFns } from "./moduleEco.vue?vue&type=template&id=66b3ee22&"
import script from "./moduleEco.vue?vue&type=script&lang=js&"
export * from "./moduleEco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports